module.exports = __webpack_public_path__ + "img/logo-awaken.e984975a.png";